import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { API_ENDPOINT } from "../constants";

/**
 * Hook for fetching virtual bore data from coordinates
 * @param {Object} coordinates - { lat, lon }
 * @param {boolean} enabled - Whether to enable the query
 */
export const useVirtualBoreData = (coordinates, enabled = false) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const fetchVirtualBoreData = async () => {
    let headers = {};
    if (isAuthenticated) {
      const token = await getAccessTokenSilently();
      headers.Authorization = `Bearer ${token}`;
    }

    const params = {
      lat: coordinates.lat,
      lon: coordinates.lon,
    };

    const response = await axios({
      url: `${process.env.REACT_APP_ENDPOINT}${API_ENDPOINT}`,
      method: "GET",
      params,
      headers,
    });

    return response.data;
  };

  return useQuery(["virtual-bore", coordinates], fetchVirtualBoreData, {
    enabled: enabled && !!(coordinates?.lat && coordinates?.lon),
    keepPreviousData: false, // Don't keep previous data to avoid confusion
    refetchOnWindowFocus: false,
    staleTime: 0, // Always refetch to ensure fresh data
    retry: 1,
  });
};
